// Centralized API URL helper for production/development environments.
// In production (single-service deploy on Railway), the API is on the same
// origin — we use an empty string so requests become relative.
// In development on localhost, we fall back to http://localhost:5001.

const isLocalDev =
  typeof window !== 'undefined' &&
  (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');

export const API_BASE_URL: string =
  process.env.REACT_APP_API_URL || (isLocalDev ? 'http://localhost:5001' : '');
